var firebaseConfig = {
	apiKey: 'AIzaSyAZZ9pbdIlFHQ9e_CGwpDi9Rq4cETivaIU',
	authDomain: 'creative-agency-f38a8.firebaseapp.com',
	databaseURL: 'https://creative-agency-f38a8.firebaseio.com',
	projectId: 'creative-agency-f38a8',
	storageBucket: 'creative-agency-f38a8.appspot.com',
	messagingSenderId: '1068644963701',
	appId: '1:1068644963701:web:fbd61edfe881834e2cef3c',
};

export default firebaseConfig;
